import equal from 'fast-deep-equal';

export function diffEntities<T, K>({
  oldEntities,
  newEntities,
  key,
  shouldCreate = () => true,
}: {
  oldEntities: T[];
  newEntities: T[];
  key: (entity: T) => K;
  shouldCreate?: (entity: T) => boolean;
}): { toCreate: T[]; toUpdate: T[]; toDelete: T[] } {
  const toCreate = newEntities.filter(e => !oldEntities.find(c => key(c) === key(e))).filter(e => shouldCreate(e));

  const toUpdate = newEntities.filter(newEntity => {
    const existingEntity = oldEntities.find(oldEntity => key(oldEntity) === key(newEntity));
    return existingEntity && !equal(existingEntity, newEntity);
  });

  const toDelete = oldEntities.filter(oldEntity => !newEntities.find(newEntity => key(newEntity) === key(oldEntity)));

  return {
    toCreate,
    toUpdate,
    toDelete,
  };
}
